export function BlobConfigDataModal() {
    this.lblCode = 1033;
    this.blobConfig = null;
    this.blobURL = null;
    this.appName = null;
    this.mainAppName = null;
    this.inputName = null;
    this.appImgUrl = null;
    this.mainAppImgUrl = null;
    this.arrowUrl = null;
    this.callcenter = null;
}
